import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';
import { upgradeAccount } from '../modules/membership_actions';

import TermsOfMembership from './CmsTermsOfMembership.jsx';

class ModalUpgradeCatalogAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account_number: '',
      zip:            '',
      email:          '',
      password:       ''
    };
    this.handleChange       = this.handleChange.bind(this);
    this.upgradeAccount     = this.upgradeAccount.bind(this);
  }
  handleChange( sType, event ) {
    let oUpdate      = {};
    oUpdate[ sType ] = event.target.value;
    this.setState( oUpdate );
  }

  upgradeAccount( evt ) {
    evt.preventDefault();
    this.props.dispatch( upgradeAccount(this.state) );
  }

  render() {
    let {dispatch} = this.props;

    return (
      <div className="modal-window login">
        <div className="modal-close" onClick={() => dispatch( closeModal() )}>&times;</div>
        <h2>Create Your Account</h2>
        <form name="upgradeAccount" onSubmit={this.upgradeAccount.bind( this )}>
          <h4><strong>Step 1:</strong> Enter your acccount information</h4>
          <input
            onChange    = {this.handleChange.bind( this, 'account_number' )}
            type        = "text"
            name        = "account_number"
            placeholder = "Account Number"
            required
          />
          <input
            onChange    = {this.handleChange.bind( this, 'zip' )}
            type        = "text"
            name        = "zip"
            placeholder = "Zipcode"
            required
          />
          <h4><strong>Step 2:</strong> Create a login</h4>
          <input
            onChange    = {this.handleChange.bind( this, 'email' )}
            type        = "email"
            value       = {this.state.email}
            placeholder = "Email Address"
            required
          />
          <input
            onChange    = {this.handleChange.bind( this, 'password' )}
            type        = "password"
            value       = {this.state.password}
            placeholder = "Password"
            required
          />
        <button className="btn-primary full-width">Upgrade Now</button>
        </form>
      </div>
    )
  }
};

export default connect()(ModalUpgradeCatalogAccount);


// WEBPACK FOOTER //
// ./src/components/ModalUpgradeCatalogAccount.jsx